import { render, staticRenderFns } from "./videoLntercom.vue?vue&type=template&id=e1c338c2&scoped=true&"
import script from "./videoLntercom.vue?vue&type=script&lang=js&"
export * from "./videoLntercom.vue?vue&type=script&lang=js&"
import style0 from "./videoLntercom.vue?vue&type=style&index=0&id=e1c338c2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c338c2",
  null
  
)

export default component.exports